var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"vizualizer",staticClass:"vizualizer"},[_c('canvas',{ref:"canvas",attrs:{"width":"393","height":"150"}}),_c('audio',{ref:"audio",attrs:{"id":"audio"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }